module.exports = __webpack_public_path__ + "img/cart-empty.01236e18.png";